<template>
  <div class="card">
    <h5 class="card-header">Internationalization</h5>
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th scope="col" class="border-top-0"></th>
            <th scope="col" class="border-top-0">Locale</th>
            <th scope="col" class="border-top-0">Verensics</th>
            <th scope="col" class="border-top-0">Organization</th>
            <th scope="col" class="border-top-0">Options</th>
          </tr>
        </thead>
        <tbody>
          <tr colspan="12" v-if="!items.length" class="text-muted text-center">
            <td colspan="12">
              {{ loadingMessage ? loadingMessage : "No internationalizations" }}
            </td>
          </tr>
          <tr v-for="item in items" :key="item.id">
            <th scope="row">{{ item.label }}</th>
            <td>{{ item.localeName }}</td>
            <td class="text-center">
              <fa icon="check" class="text-success" v-if="item.verensicsLocaleText" />
              <fa icon="times" class="text-danger" v-if="!item.verensicsLocaleText" />
            </td>
            <td class="text-center">
              <fa icon="check" class="text-success" v-if="item.organizationLocaleText" />
              <fa icon="times" class="text-danger" v-if="!item.organizationLocaleText" />
            </td>
            <td class="text-center">
              <button class="btn btn-sm btn-link p-0 mx-1" type="button" @click="openModal(item)">
                <fa icon="pencil-alt" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Modal -->
    <div ref="modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modal" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content" style="max-height: 600px;">
          <div class="modal-body" v-if="modalItem">
            <form ref="form" class="needs-validation" :class="formWasValidated ? 'was-validated' : ''" novalidate @submit.prevent>
              <div class="modal-header">
                <h5 class="modal-title">Edit Internationalization</h5>
                <button type="button" class="close" aria-label="Close" @click="closeModal">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <ErrorSummary :error="error" />
                <div class="form-group row">
                  <label for="text" class="col-sm-2 col-form-label">Description:</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control-plaintext" readonly :value="modalItem.label" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="text" class="col-sm-2 col-form-label">Locale:</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control-plaintext" readonly :value="modalItem.localeName" />
                  </div>
                </div>
                <div class="form-group">
                  <label for="text" class="col-form-label">Your organization's custom text:</label>
                  <textarea
                    v-model="modalItem.organizationLocaleText"
                    class="form-control"
                    maxlength="3000"
                    rows="5"
                    :placeholder="modalItem.verensicsLocaleText"
                  ></textarea>
                  <small class="form-text text-muted">Enter your organization's alternative text, or leave blank to use Verensics' default value.</small>
                  <div class="invalid-feedback">Please provide a valid value.</div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="saveModal">
              <span v-if="loadingMessage" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              {{ savingMessage ? savingMessage : "Save" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import ErrorSummary from "@/components/ErrorSummary.vue";

export default {
  components: {
    ErrorSummary,
  },
  props: {
    organizationId: String,
  },
  data() {
    return {
      loadingMessage: null,
      savingMessage: null,
      formWasValidated: false,
      error: null,

      items: [],

      modalItem: null,
    };
  },
  created() {
    this.load();
  },
  mounted() {
    $('[data-toggle="tooltip"]').tooltip({ boundary: "window" });
  },
  watch: {
    organizationId() {
      this.load();
    },
  },
  methods: {
    load() {
      this.loadingMessage = "Loading...";
      this.$axios
        .get(`/v1/organizations/${this.organizationId}/internationalizations`)
        .then(res => (this.items = res.data))
        .catch(() => this.$router.push("/404"))
        .finally(() => (this.loadingMessage = null));
    },
    reset() {
      this.loadingMessage = false;
      this.savingMessage = false;
      this.formWasValidated = false;
      this.error = null;
    },
    openModal(item) {
      this.reset();
      this.modalItem = {
        code: item.code,
        label: item.label,
        localeCode: item.localeCode,
        localeName: item.localeName,
        verensicsLocaleText: item.verensicsLocaleText,
        organizationLocaleText: item.organizationLocaleText,
      };
      $(this.$refs.modal).modal("show");
    },
    closeModal() {
      $(this.$refs.modal).modal("hide");
      this.reset();
      this.load();
    },
    saveModal() {
      const payload = {
        organizationLocaleText: this.modalItem.organizationLocaleText,
      };

      // reset
      this.reset();

      // validations
      if (!this.$refs.form.checkValidity()) {
        this.formWasValidated = true;
        return;
      }

      // api
      this.savingMessage = "Saving...";
      this.$axios
        .put(`/v1/organizations/${this.organizationId}/internationalizations/${this.modalItem.code}/${this.modalItem.localeCode}`, payload)
        .then(() => {
          this.reset();
          this.closeModal();
        })
        .catch(err => (this.error = err))
        .finally(() => (this.savingMessage = null));
    },
  },
};
</script>

<style lang="scss" scoped>
.table-responsive {
  height: 400px;
  overflow-y: scroll;

  table {
    margin-bottom: 0;

    thead tr:nth-child(1) th {
      background: white;
      position: sticky;
      top: 0;
      z-index: 10;
    }

    .enabled-header {
      width: 115px;
    }
  }
}

.custom-control-label {
  cursor: pointer;
}
</style>
